import type { IParcelHandoff } from "../store/useParcelHandoffs";

/**
 * Pickups and drop-offs of one handoff. Rows saved before a registration
 * could carry both have no pickupCount/dropoffCount, so their single
 * direction says which side the whole parcelCount belongs to.
 */
export const parcelSplit = (
  handoff?: Partial<
    Pick<
      IParcelHandoff,
      "direction" | "parcelCount" | "pickupCount" | "dropoffCount"
    >
  > | null
): { pickup: number; dropoff: number } => ({
  pickup: Number(
    handoff?.pickupCount ??
      (handoff?.direction === "PICKUP" ? handoff?.parcelCount : 0) ??
      0
  ),
  dropoff: Number(
    handoff?.dropoffCount ??
      (handoff?.direction === "DROPOFF" ? handoff?.parcelCount : 0) ??
      0
  ),
});
